import { AST } from '../ast';
import { Expression } from '../builder/expression';
import { Ty } from '../ty';

export const format = (args: readonly AST.ExprIR[]): AST.ExprIR => {
  /** Scalers that are not represented as "''".  */
  const nonEmptyScalers = args.filter(
    (arg) => !(arg.t === 'scalar' && arg.val === '')
  );

  if (nonEmptyScalers.length === 0) {
    return { t: 'scalar', val: '', ty: Ty.nn('string') };
  }

  return Expression.fromAst({
    t: 'function-call',
    op: 'concat',
    args: nonEmptyScalers.map((arg) => {
      const original = Expression.fromAst(arg);
      const casted = original.implements('string')
        ? original
        : original.cast('string');
      const { ast } = casted.ty.nullable ? casted.coalesce('') : casted;
      return ast;
    }),
  }).ir();
};

export const format_nullable = (args: readonly AST.ExprIR[]): AST.ExprIR => {
  if (args.length === 0) {
    return { t: 'scalar', val: '', ty: Ty.nn('string') };
  }

  return Expression.fromAst({
    t: 'function-call',
    op: 'concat',
    args: args.map((arg) => {
      const original = Expression.fromAst(arg);
      const casted = original.implements('string')
        ? original
        : original.cast('string');
      return casted.ast;
    }),
  }).ir();
};
